<template>
    <gg-card>
      <gg-card-header>
        Two-factor Authentication
      </gg-card-header>
      <gg-card-text>
        <v-alert v-if="isEnabled" type="success" dense>
          Two-factor Authentication is enabled
        </v-alert>

        <h4>What is Two Factor Verification (2FA)?</h4>
        <p>
          When enabled with two factor verification, your account will be nearly impossible to hack and is secure
          against hackers and identity theft.
        </p>
        <h4>When 2FA is enabled, you will:</h4>
        <ul>
          <li>
            Still be able to use your GreenGeeks username and password as usual.
          </li>
          <li>
            Enter a 2FA code generated by an app on your mobile phone.
          </li>
        </ul>
        <br>
        <p>
          The combination of you being the sole person with access to your password and your phone ensures that
          no one but you can have access to your account.
        </p>
        <p>
          To begin the process of setting up 2FA for your account, please click the button below.
        </p>
      </gg-card-text>
      <v-card-actions>
        <gg-btn
          v-if="!isEnabled"
          primary
          @click="open2FAModal('enable')"
        >
          Enable Two-factor Security
          <span class="visually-hidden text-lowercase">button</span>
        </gg-btn>
        <gg-btn
          v-else
          color="red"
          primary dark
          @click="open2FAModal('disable')"
        >
          Disable Two-factor Security
          <span class="visually-hidden text-lowercase">button</span>
        </gg-btn>
      </v-card-actions>
      <two-factor-auth-modal :show="showModal" @close="close"/>
    </gg-card>
</template>

<script>
import { mapGetters } from 'vuex'
import TwoFactorAuthModal from 'Components/Profile/Security/TwoFactorAuth/TwoFactorAuthModal'

export default {
  name: 'TwoFactorAuthCard',
  components: {
    TwoFactorAuthModal
  },
  data () {
    return {
      showModal: false,
      modalMode: ''
    }
  },
  computed: {
    ...mapGetters(['SessionProfile']),
    isEnabled () {
      return !!this.SessionProfile.totp_enabled
    }
  },
  methods: {
    open2FAModal (mode = 'enable') {
      this.showModal = true
      this.modalMode = mode
    },
    close () {
      this.showModal = false
      this.modalMode = ''
    }
  },
}
</script>

<style scoped>
  .card-size {
    height: calc(100% - 54px);
  }
</style>
